/* ZR CORES (2026-10-09) — prévia de cor no card, sem juntar produtos.
   O clique num swatch troca imagem, nome, link, preço e a variante da
   compra rápida do card para os dados REAIS do produto irmão (vindos dos
   data-* renderizados pelo Liquid via metafields). Nada é simulado com CSS.
   A compra rápida usa o hidden [name=id] no submit, então atualizar o input
   garante que nunca adiciona variante do produto anterior. */
(function () {
  function closestCard(el) {
    if (el.closest) return el.closest('[data-zr-card]');
    return null;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest
      ? event.target.closest('[data-zr-cor-btn]')
      : null;
    if (!btn) return;

    /* Na página do produto os swatches são links reais — deixa navegar. */
    if (btn.tagName === 'A') return;

    var card = closestCard(btn);
    if (!card) return;
    event.preventDefault();

    if (btn.classList.contains('is-active')) return;

    var mediaLink = card.querySelector('[data-zr-card-link]');
    var titleLink = card.querySelector('[data-zr-card-title]');
    var titleText = card.querySelector('[data-zr-card-title-text]');
    var mainImg = card.querySelector('[data-zr-card-img]');
    var hoverImg = card.querySelector('[data-zr-card-img-hover]');
    var priceEl = card.querySelector('[data-zr-card-price]');
    var compareEl = card.querySelector('[data-zr-card-compare]');
    var parcelaEl = card.querySelector('[data-zr-card-parcela]');
    var variantInput = card.querySelector('[data-zr-card-variant]');
    var buyBtn = card.querySelector('[data-zr-card-btn]');

    var url = btn.getAttribute('data-url') || '';
    var title = btn.getAttribute('data-title') || '';
    var img = btn.getAttribute('data-img') || '';
    var img2 = btn.getAttribute('data-img2') || '';
    var price = btn.getAttribute('data-price') || '';
    var compare = btn.getAttribute('data-compare') || '';
    var parcela = btn.getAttribute('data-parcela') || '';
    var variantId = btn.getAttribute('data-variant') || '';
    var disponivel = btn.getAttribute('data-disponivel') === 'true';

    if (mainImg && img) {
      mainImg.classList.add('is-switching');
      mainImg.setAttribute('src', img);
      mainImg.setAttribute('alt', title);
      window.setTimeout(function () {
        mainImg.classList.remove('is-switching');
      }, 300);
    }
    if (hoverImg) {
      if (img2) {
        hoverImg.setAttribute('src', img2);
        hoverImg.setAttribute('alt', title);
        hoverImg.style.display = '';
      } else if (img) {
        hoverImg.setAttribute('src', img);
        hoverImg.setAttribute('alt', title);
      }
    }
    if (mediaLink && url) mediaLink.setAttribute('href', url);
    if (titleLink && url) titleLink.setAttribute('href', url);
    if (titleText && title) titleText.textContent = title;
    if (priceEl && price) priceEl.textContent = price;
    if (compareEl) {
      if (compare) {
        compareEl.textContent = compare;
        compareEl.style.display = '';
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    }
    if (parcelaEl && parcela) parcelaEl.textContent = parcela;
    if (variantInput && variantId) variantInput.value = variantId;
    if (buyBtn) {
      buyBtn.disabled = !disponivel;
      buyBtn.textContent = disponivel ? 'COMPRAR' : 'ESGOTADO';
    }

    card.querySelectorAll('[data-zr-cor-btn]').forEach(function (b) {
      var active = b === btn;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  });

  /* Teclado: Enter/Espaço em <button> já dispara click nativamente. */
})();
